import styled from "styled-components";

const Alternate = styled.div`
  margin: 0 0 50px 0;
`;

export default Alternate;
